module.exports = __webpack_public_path__ + "static/img/foshou.4803f237.png";